module.exports = __webpack_public_path__ + "img/2.ee8680b9.png";